// extracted by mini-css-extract-plugin
export default {"feature_cards_container":"feature_cards_container___fMc6V","cards":"cards___SK51i","card":"card___WJ1jM","title":"title___b4vQh","subtitle":"subtitle___DYfva"};